

// Περιστέρι Θηβών 201, Περιστέρι, 12134 210 2241220
// Άγιος Δημήτριος Λεωφ. Αγίου Δημητρίου 295, 17342 210 9850072
// Σπάτα Οικοδ. τετρ. Ε71 θέση Γιαλού (Designer Outlet Athens) 210 2241900
// Κηφισιά Κασσαβέτη 6, Κηφισιά 14562 210 3002295
// Ελληνικό Τιτάνων 17, Ελληνικό 16777 210 2241095

// Click & Collect locator (#20815): all five Pharmacy295 pickup points are in
// Attica, but area names like "Ελληνικό" are ambiguous across Greece — Google,
// with no bias, resolves "Ελληνικό" to the village near Άγιος Νικόλαος, Crete,
// landing the reference point ~300km away so the Athens pharmacy can never be
// hoisted. This soft bias (strictBounds stays false) prefers Attica predictions
// so the Athens locality wins, while a Box Now search in another city still
// works. Applied only when `local` is set (the locator), so the courier
// shipping-address field is unaffected.
const ATTICA_BIAS_BOUNDS = {
  north: 38.15,
  south: 37.8,
  east: 23.98,
  west: 23.55,
};

export default {
  props: {
    from: {},
    guest: {},
    local: {},
    emit: {},
    cart: {
      type: Object,
      default: (_) => ({ shipping: {} }),
    },
  },
  data() {
    return {
      ready: false,
      id: this.uid(),
      hasError: false,
      errorMessage: "",
      warningMessage: "",
      initial: this.initialValue()
    };
  },
  watch: {
    "$store.getters.readyness.googleMapsAutocomplete": {
      handler(v) {
        this.init();
      },
      deep: true,
    },
  },
  mounted() {
    if ((this.$store.getters.readyness || {}).googleMapsAutocomplete) {
      this.init();
    }
    this.$nuxt.$on("clearMe", (_) => {
      this.initial = "";
      if (process.browser && document.querySelector(`#g${this.id}`)) {
        document.querySelector(`#g${this.id}`).value = "";
      }
    });
  },
  methods: {
    uid() {
      return Date.now().toString(36) + Math.random().toString(36).substr(2);
    },
    initialValue() {
      let t = `${
        (this.$store.getters.cart.shipping.address || {}).address || ""
      }${
        (this.$store.getters.cart.shipping.address || {}).address ? ", " : ""
      }${(this.$store.getters.cart.shipping.address || {}).town || ""} ${
        (this.$store.getters.cart.shipping.address || {}).postal_code || ""
      }`;
      if (t.slice(0, 3) == " , ") {
        t = t.slice(3, t.length);
      }
      return (t || "").trim();
    },
    onNativeAutocomplete(e) {
      console.log(e);
      const value = e.target.value;
      if (!value || value.length < 3) return;
      
      // Use Google Geocoder to search for the address.
      // The Geocoder takes ONE country string -- unlike the Places Autocomplete
      // in init() below, which takes an array and throws here:
      //   InvalidValueError: in property country: not a string
      // And restricted to GR a Cyprus address does not fail, it answers OK with
      // the centroid of Greece -- which is why the locker search ran hundreds of
      // kilometres away and found nothing (#23572). So: ask GR first, and only
      // when the best Google can do is the country itself, ask CY.
      const geocoder = new google.maps.Geocoder();
      const geocode = (country) =>
        new Promise((resolve) => {
          const request = { address: value, componentRestrictions: { country } };
          // Locator only: bias the geocode toward Attica (see ATTICA_BIAS_BOUNDS).
          if (this.local) {
            request.bounds = ATTICA_BIAS_BOUNDS;
          }
          geocoder.geocode(request, (results, status) =>
            resolve(status === "OK" && results && results[0] ? results[0] : null)
          );
        });
      const vague = (place) => !place || (place.types || []).includes("country");
      (async () => {
        let place = await geocode("GR");
        // The store locator is Attica-only, so it never asks about Cyprus.
        if (vague(place) && !this.local) {
          place = (await geocode("CY")) || place;
        }
        if (vague(place)) {
          return;
        }
        let r = this.$hyperUtility.handleAutocomplete(place, this.emit);
        if (this.local && r) {
          this.$emit("localComplete", r);
        }
      })();
    },
    init() {
      if (this.ready && !process.browser) {
        return;
      }
      let options = {
        types: [],
        componentRestrictions: { country: ["GR", "CY"] },
        fields: [
          "address_components",
          "geometry",
          "icon",
          "name",
          "formatted_address",
        ],
      };
      // Locator only: bias predictions toward Attica (see ATTICA_BIAS_BOUNDS) so
      // ambiguous pharmacy-area names resolve to the Athens locality. Soft bias —
      // strictBounds is left false so other-city searches still resolve.
      if (this.local) {
        options.bounds = ATTICA_BIAS_BOUNDS;
      }
      let a = new google.maps.places.Autocomplete(
        document.querySelector(`#g${this.id}`),
        options
      );
      let self = this;
      a.addListener("place_changed", function (v) {
        let r = self.$hyperUtility.handleAutocomplete(a.getPlace(),self.emit);
        if (self.local && r) {
          self.$emit("localComplete", r);
        }
      });
      this.ready = true;
    },
  },
};
